import { render, staticRenderFns } from "./invoicesList.vue?vue&type=template&id=c34d1d08&"
import script from "./invoicesList.vue?vue&type=script&lang=js&"
export * from "./invoicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports